import { render, staticRenderFns } from "./IcoTpqi.vue?vue&type=template&id=0606b6b0"
import script from "./IcoTpqi.vue?vue&type=script&lang=js"
export * from "./IcoTpqi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports